import { NavLink } from "react-router-dom";

const NewNFTs = ({data}) => {

  const {
    popularOfTheWeek__titleHighlight,
    popularOfTheWeek__title,
    popularOfTheWeekList
  } = data

  return (
      <section className="popularOfTheWeek">
        <h2 className="popularOfTheWeek__title">
          <span className="highlight">{popularOfTheWeek__titleHighlight}</span>{popularOfTheWeek__title}
        </h2>
        <div className="row">
          {popularOfTheWeekList && popularOfTheWeekList.map((item , key) => (
            <div className="col-lg-4 col-md-6" key={key}>
              <NavLink to="/item-details" className="popular__card">
                <div className="card__header">
                  <p>{item.title}</p>
                  <img loading="lazy" data-src={item.card__link} alt="link astronauta 1" className="card__link" />
                </div>
                <div className="card__info">
                  <p className="card__artist subtitle">{item.OwnerKey}</p>
                  <p className="card__value highlight">{item.OwnerVal}</p>
                </div>
                <div className="card__info">
                  <p className="card__artist subtitle">{item.CategoryKey}</p>
                  <p className="card__value highlight">{item.CategoryVal}</p>
                </div>
                <div className="nft-img-wrapper">
                  <img loading="lazy" data-src={item.NftImgWrapper} alt="astronauta 1 NFT" />
                </div>
                <div className="card__info">
                  <p className="card__artist subtitle">{item.PriceKey}</p>
                  <p className="card__value highlight">{item.PriceVal}</p>
                </div>
              </NavLink>
            </div>
          ))}
        </div>
      </section>
  );
}

export default NewNFTs;